import axios from 'axios';
import {getAuthHeader} from '../global_helpers/authHeader.js';
import {getTPAID} from '../global_helpers/sessionReturn.js';
import {
    OpportunitySection,
    PlanTypeSection,
    CashBalanceSection,
    RevShareSection,
    ProviderSection,
    TemplateSection,
    BrokerSection,
    AdvisorSection,
    PricingSection,
    PricingOptions,
} from './proposalBuilderSections.js'

const state = {
    opportunitySection: new OpportunitySection(),
    planTypeSection: new PlanTypeSection(),
    cashBalanceSection: new CashBalanceSection(),
    revShareSection: new RevShareSection(),
    providerSection: new ProviderSection(),
    templateSection: new TemplateSection(),
    brokerSection: new BrokerSection(),
    advisorSection: new AdvisorSection(),
    pricingSection: new PricingSection(),
    pricingOptions: new PricingOptions(),

    proposalViewModels: [],
    savedProposals: [],
    proposalTemplates: [],
    showSection: {
        cashBalance: false,
        revShare: false,
        provider: false,
        template: false,
        broker: false,
        advisor: false,
        pricing: false,
    },
    isPDFGenerated: false,
};

const getters = {
    getOpportunitySection: (state) => state.opportunitySection,
    getPlanTypeSection: (state) => state.planTypeSection,
    getCashBalanceSection: (state) => state.cashBalanceSection,
    getRevShareSection: (state) => state.revShareSection,
    getProviderSection: (state) => state.providerSection,
    getTemplateSection: (state) => state.templateSection,
    getBrokerSection: (state) => state.brokerSection,
    getAdvisorSection: (state) => state.advisorSection,
    getPricingSection: (state) => state.pricingSection,
    getPricingOptions: (state) => state.pricingOptions,
    getShowSection: (state) => state.showSection,
    getProposalViewModels: (state) => state.proposalViewModels,
    getSavedProposals: (state) => state.savedProposals,
    getProposalTemplates: (state) => state.proposalTemplates,
    getIsPDFGenerated: (state) => state.isPDFGenerated,
};

const actions = {
    async clearProposalBuilderState({commit}){
        commit('clearProposalBuilderState');
    },

    async clearProposalViewModels({commit}){
        commit('clearProposalViewModelsState');
    },

    async clearSavedProposalsState({commit}){
        commit('clearSavedProposalsState');
    },

    async loadRevSharePrograms({commit}){
        console.log('loadRevSharePrograms');
        axios.get('/recordkeeper/',getAuthHeader())
        .then(response => {
            commit('loadRevShareProgramsState',response.data);
        })
    },

    async loadProposalTemplates({commit}){
        console.log('loadProposalTemplates');
        let authHeader = getAuthHeader();
        axios.get(`/template/list/?entity_type=tpa&entity_id=${getTPAID()}&template_type=proposal`, authHeader)
        .then(response => {
            commit('loadProposalTemplatesState',response.data);
        });
    },

    async loadWholesalerTemplatePairs({commit},data){
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/wholesaler/ddl/?entity_type=tpa&entity_id=${tpaId}&rk_id=${data}`, authHeader)
        .then(response => {
            commit('updateWholesalerTemplateState',response.data);
        });
    },

    async loadDefaultPricing({commit},arg){
        console.log('loadDefaultPricing');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/pricing_default/selections/?entity_type=tpa&entity_id=${tpaId}&plan_type=${arg.planType}`, authHeader)
        .then(response => {
            // console.log('loadDefaultPricing response');
            // console.log(response.data);
            // console.log(JSON.stringify(response.data));
            commit('loadDefaultPricingState', response.data);
            arg.callback();
        })
    },

    async loadDefaultPricingOptions({commit}){
        console.log('loadDefaultPricingOptions');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/pricing_default/options/?entity_type=tpa&entity_id=${tpaId}&plan_type=takeover`, authHeader)
        .then(response => {
            // console.log('loadDefaultPricingOptions response');
            // console.log(JSON.stringify(response.data));
            commit('loadDefaultPricingOptionsState', response.data);
        })
    },

    async loadBrokerDealers({commit}){
        console.log('loadBrokerDealers');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        axios.get(`/broker/list/?tpa_id=${tpaId}`,authHeader)
        .then(response => {
            commit('loadBrokerDealersState',response.data);
        })
    },
    
    async clearBrokerState({commit}){
        console.log('clearBrokerState called');
        commit('clearBrokerState');
    },
    
    async updateBrokerDefaults({dispatch},defaults){
        // console.log('updateBrokerDefaults called');
        let authHeader = getAuthHeader();
        let tpaId = getTPAID();
        // console.log(defaults);
        let body = { broker_ids: defaults };
        axios.put('/broker/default/?tpa_id='+tpaId, body, authHeader)
        .catch((err) => {
            console.log(err);
            dispatch('raiseMessage', 'There was an error updating your default brokers.');
        });
    },
    
    async loadAdvisorState({commit}, id){
        console.log('loadAdvisorState called');
        console.log(id);
        let tpa_id = getTPAID();
        let authHeader = getAuthHeader();
        axios.get("/advisor/list/?broker_id="+id+"&tpa_id="+tpa_id, authHeader)
        .then((res) => {
            // console.log(res.data);
            commit('setAdvisorState', res.data);
        });
    },
    
    async clearAdvisorState({commit}){
        console.log('clearAdvisorState called');
        commit('clearAdvisorState');
    },

    async getProposalViewModelCalculation({commit, dispatch}, proposalViewModel){
        let authHeader = getAuthHeader();
        axios.post('/proposal/viewmodel/calculations/', proposalViewModel, authHeader)
        .then((res) => {
            commit('appendProposalViewModel', res.data)
        })        
        .catch(err =>{
            console.log(err)
            dispatch('raiseMessage','There was an error rendering your calculations', {root: true});
        });        
    },

    async saveProposalViewModels({commit,dispatch},callback){
        console.log(`saveProposalViewModels called`);
        let authHeader = getAuthHeader();
        let requests = [];
        let proposals = [];
        commit('setIsPDFGenerated',true);
        state.proposalViewModels.forEach(vm => {
            requests.push(axios.post('/proposal/viewmodel/save/', vm, authHeader));
        })
        await axios.all(requests)
        .then(axios.spread((...res) => {
                res.forEach(r => proposals.push(r.data));
            })
        )
        .catch(err => {
            console.log(err)
            dispatch('raiseMessage','There was an error saving your proposal(s)!', {root: true});
        });
        console.log(proposals);
        commit('setSavedProposalsState',proposals);
        callback(); //used to send the email after the proposals are all saved
    }
};

const mutations = {
    clearProposalBuilderState (state){
        state.planTypeSection = new PlanTypeSection();
        state.cashBalanceSection = new CashBalanceSection();
        state.revShareSection = new RevShareSection();
        state.providerSection = new ProviderSection();
        state.brokerSection = new BrokerSection();
        state.advisorSection = new AdvisorSection();
        state.pricingSection = new PricingSection();
        state.proposalViewModels = [];
        state.showSection = {
            cashBalance: false,
            revShare: false,
            provider: false,
            broker: false,
            advisor: false,
            pricing: false,
        };
        state.isPDFGenerated = false;
    },

    clearSavedProposalsState(state){
        state.savedProposals = [];
    },

    setSavedProposalsState(state,data){
        console.log('setSavedProposalsState mutation called');
        state.savedProposals = data;
    },

    setIsPDFGenerated(state,value){
        state.isPDFGenerated = value;
    },

    clearProposalViewModelsState (state){
        state.proposalViewModels = [];
    },

    appendProposalViewModel(state,data){
        console.log('appendProposalViewModel mutation called');
        console.log(data);
        state.proposalViewModels.push(data);
    },

    loadProposalTemplatesState(state,data){
        state.proposalTemplates = data
        data.forEach(t => {
            if (t.is_default) state.defaultProposalTemplate = t;
        });
    },

    loadRevShareProgramsState(state, data){
        state.revShareSection.revSharePrograms = data;
    },

    updateWholesalerTemplateState(state, data){
        state.providerSection.load(data);
    },
    
    loadDefaultPricingState(state, data){
        // console.log('loadDefaultPricingState called');
        state.pricingSection.loadData(data);
    },
    
    loadDefaultPricingOptionsState(state, data){
        // console.log('loadDefaultPricingOptionsState called');
        state.pricingOptions = new PricingOptions(data);
    },

    loadBrokerDealersState(state, data){
        state.brokerSection.loadOptions(data);
        state.advisorSection.loadBrokerOptions(data);
    },
        
    setAdvisorState(state, data){
        // console.log('setAdvisorState called');
        state.advisorSection.loadAdvisorOptions(data);
    },
    
    clearAdvisorState(state){
        state.advisorSection.reset();
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
